import { render, staticRenderFns } from "./SendSMS.vue?vue&type=template&id=106440a5&scoped=true&"
import script from "./SendSMS.vue?vue&type=script&lang=js&"
export * from "./SendSMS.vue?vue&type=script&lang=js&"
import style0 from "./SendSMS.vue?vue&type=style&index=0&id=106440a5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106440a5",
  null
  
)

export default component.exports